if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.innerForm = this.querySelector('.product-form--inner');
        this.isFixed = false;
        this.observeScroll();
      }

      observeScroll() {
        if (!this.innerForm) return;

        const observer = new IntersectionObserver((entries) => {
          // Check if window width is less than 768px before applying animation
          if (window.innerWidth < 768) {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && !this.isFixed) {
                this.innerForm.classList.add('transitioning');
                this.innerForm.style.transition = 'transform 0.3s ease-in-out';
                this.innerForm.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  this.innerForm.classList.add('fixed-bottom');
                  this.innerForm.style.transform = 'translateY(0)';
                  this.isFixed = true;
                }, 300);

              } else if (entry.isIntersecting && this.isFixed) {
                this.innerForm.style.transition = 'transform 0.3s ease-in-out';
                this.innerForm.style.transform = 'translateY(100%)';
                setTimeout(() => {
                  this.innerForm.style.transition = '';
                  this.innerForm.style.transform = '';
                  this.innerForm.classList.remove('fixed-bottom');
                  this.isFixed = false;
                }, 100);
              }
            });
          }
        }, { threshold: 0.1 });

        observer.observe(this);
      }

      addToCart(config, formData, url = routes.cart_add_url) {

          // Returned so a follow-up add (the discount_data gift) can wait for this one.
          // Resolves true only for a confirmed add (skip-cart redirects on that).
          return fetch(url, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return false;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return false;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return true;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
              return true;
            })
            .catch((e) => {
              console.error(e);
              return false;
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }


        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);

            const discountDataInputEarly = this.form.querySelector('[name="discount_data"]');
            const productInfo = this.closest('product-info');
            const shouldStripKachingBundles =
              !productInfo || productInfo.dataset.hideKachingBundles !== 'false';
            if (shouldStripKachingBundles && discountDataInputEarly && discountDataInputEarly.value) {
              ['properties[__kaching_bundles]', 'properties[__kaching_session_id]'].forEach((key) => {
                formData.delete(key);
              });
            }

            if (this.cart) {
                formData.append(
                    'sections',
                    this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }

            // The theme owns the bundle/single quantity — NOT Kaching. Kaching's app script
            // (kaching-bundles.js) hooks the ATC button and writes its deal's tier qty into the
            // quantity input on click (regardless of which tier the shopper picked), before this
            // submit handler runs. So we take the last word here: use the checked tier's own
            // add-qty. `data-add-qty` = the tier quantity for discount tiers, and (for the base
            // "single" tier) a mirror of the stepper that Kaching does not clobber. Falls back to
            // the radio value if the section markup is stale. (Older double-multiply -> 6x6=36.)
            const checkedBundle = document.querySelector('[name="bundles"]:checked');
            if (checkedBundle) {
                const addQty = parseInt(checkedBundle.dataset.addQty || checkedBundle.value, 10);
                if (addQty > 0) { formData.delete('quantity'); formData.append('quantity', addQty); }
            }

            let sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        // &&
        //     document.querySelector('.variant-selector input:checked') &&
        //     document.querySelector('.variant-selector input:checked').value.indexOf(' x ') !== -1
            if (
                sellingPlanInput
            ) {
                formData.delete('selling_plan');
                formData.append('selling_plan', sellingPlanInput.value);

                // formData.delete('quantity');
                // formData.append('quantity', 1);
            } else {
                formData.delete('selling_plan');
            }


            config.body = formData;

            // IO-5815: a Kaching bar with add-ons (gifts, upsells, checkbox upsells, personalisation,
            // collection-break slots), or a bundle / mix-and-match / sku bar. The lines go in ONE JSON
            // add, carrying the same __kaching_bundles properties Kaching's widget writes, so its
            // function prices them. `kaching_bundles=true` in the URL keeps Kaching's own fetch
            // interceptor from rewriting the request.
            let addUrl = `${routes.cart_add_url}`;
            const bundlesUI = checkedBundle && checkedBundle.closest('kaching-bundles-ui');
            const kachingGift = bundlesUI && typeof bundlesUI.getKachingGiftLines === 'function'
              ? bundlesUI.getKachingGiftLines(checkedBundle)
              : null;
            if (kachingGift && 'blocked' in kachingGift) {
              // A required Kaching personalisation / variant / slot is missing: stop here.
              this.handleErrorMessage(kachingGift.blocked || '!', kachingGift.colors);
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
              return;
            }
            if (kachingGift) {
              const mainId = Number(formData.get('id'));
              let items;
              if (kachingGift.items) {
                // The bar is not a line of this product: every line comes from the bar itself.
                items = kachingGift.items;
              } else {
                const props = {};
                formData.forEach((value, key) => {
                  const m = key.match(/^properties\[(.+)\]$/);
                  if (m) props[m[1]] = value;
                });
                props.__kaching_bundles = JSON.stringify(kachingGift.main);
                delete props.__kaching_session_id;
                // mainQty: collection-break slots swapped for other products take units off this line.
                const mainQty = kachingGift.mainQty || Number(formData.get('quantity')) || 1;
                const main = { id: mainId, quantity: mainQty, properties: props };
                if (kachingGift.mainPlanId) main.selling_plan = kachingGift.mainPlanId; // the bar's own plan wins
                else if (formData.get('selling_plan')) main.selling_plan = Number(formData.get('selling_plan'));
                // Add-on lines (gifts, upsells, personalisation) nest under the main line; collection-
                // break lines (`top`) are top-level, as Kaching's widget adds them. A deal that
                // disables nested lines posts them flat.
                items = [main].concat(kachingGift.lines.map((g) => {
                  const line = {
                    id: g.variantId,
                    quantity: g.qty,
                    properties: Object.assign({ __kaching_bundles: JSON.stringify(g.props) }, g.extra || {}),
                  };
                  if (g.sellingPlan) line.selling_plan = g.sellingPlan;
                  if (!g.top && !kachingGift.noNest) line.parent_id = mainId;
                  return line;
                }));
              }
              // Deal flag "split quantity break items": one line per unit, told apart by a line id.
              if (kachingGift.split && !items.some((it) => it.parent_id)) {
                items = items.flatMap((it, idx) => {
                  if (!it.properties || !it.properties.__kaching_bundles) return [it];
                  const kb = JSON.parse(it.properties.__kaching_bundles);
                  return Array.from({ length: it.quantity }, (x, unit) => Object.assign({}, it, {
                    quantity: 1,
                    properties: Object.assign({}, it.properties, { __kaching_bundles: JSON.stringify(Object.assign({}, kb, { line: kachingGift.nonce + ':' + idx + ':' + unit })) }),
                  }));
                });
              }
              const body = { items: items };
              if (formData.get('sections')) {
                body.sections = String(formData.get('sections')).split(',');
                body.sections_url = formData.get('sections_url');
              }
              config.headers['Content-Type'] = 'application/json';
              config.body = JSON.stringify(body);
              addUrl += (addUrl.indexOf('?') === -1 ? '?' : '&') + 'kaching_bundles=true';
            }

            const discountDataInput = discountDataInputEarly;
            const giftIdsInput = this.form.querySelector('[name="gift_ids"]');
            // IO-5815: a Kaching gift (picked, or unlocked progressive) REPLACES the discount_data
            // dovana for this add — the same promo can be configured in both UVS and Kaching, and the
            // shopper gets one gift. An add with only upsells / personalisation keeps the dovana.
            const giftIdStrings = !(kachingGift && kachingGift.hasGift) && giftIdsInput?.value
              ? giftIdsInput.value.split(',').map(s => s.trim()).filter(Boolean)
              : [];

            if (giftIdStrings.length > 1) {
              this.showGiftSelectionModal(giftIdStrings.map(Number), formData, config, addUrl);
              return;
            }

            // Deal setting "skip cart": the deal's earlier lines leave the cart first, then the shopper
            // goes straight to checkout once the add is through.
            const skipCart = !!(bundlesUI && typeof bundlesUI.skipCartEnabled === 'function' && bundlesUI.skipCartEnabled(checkedBundle));
            let oldKeys = [];
            let added = false;
            const toCheckout = () => {
              if (!skipCart || !added) return null;
              // Only a confirmed add clears the deal's earlier lines, then on to checkout.
              return bundlesUI.removeCartKeys(oldKeys).then(() => {
                window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
              });
            };
            const mainAdd = (skipCart ? bundlesUI.dealCartKeys() : Promise.resolve([]))
              .then((keys) => { oldKeys = keys; return this.addToCart(config, formData, addUrl); })
              .then((ok) => { added = ok === true; });

            if (giftIdStrings.length === 1) {
              const giftFormData = new FormData();
              giftFormData.append('id', giftIdStrings[0]);
              giftFormData.append('quantity', 1);
              // Same `_gift_parent` stamp the multi-gift modal path writes: the cart templates key
              // their gift treatment (locked qty, sorted last, no product link) off this property,
              // so without it a single gift renders as an ordinary purchased line.
              giftFormData.append('properties[_gift_parent]', formData.get('id'));
              const giftConfig = fetchConfig('javascript');
              giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete giftConfig.headers['Content-Type'];
              giftConfig.body = giftFormData;
              // IO-5815: send the gift only AFTER the main add has finished. Fired in parallel,
              // one of the two concurrent cart writes was intermittently lost (the gift line
              // simply never reached the cart). Kaching Cart's fetch wrapper re-renders the
              // drawer on this add; refreshCart() is a nudge for when it doesn't.
              mainAdd
                .then(() => (this.error ? null : fetch(`${routes.cart_add_url}`, giftConfig))) // no gift if the main add failed
                .then(() => { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); })
                .catch(() => {})
                .then(toCheckout);
            } else {
              mainAdd.then(toCheckout);
            }
        }

        showGiftSelectionModal(giftIds, formData, config, addUrl) {
          const lookupEl = document.getElementById('gift-variant-lookup');
          const lookupArr = lookupEl ? JSON.parse(lookupEl.textContent) : [];
          const lookup = {};
          for (const v of lookupArr) lookup[v.id] = v;

          const buildInner = (id, idx, info) => {
            const base = info && (info.product_title || info.title)
              ? ((info.product_title || '') + (info.title && info.title !== 'Default Title' ? ' – ' + info.title : '')).trim()
              : 'Dovana ' + (idx + 1);
            const img = info && info.image
              ? '<img src="' + info.image + '" alt="" class="gift-selection-modal__img">'
              : '';
            return img + '<span>' + base + '</span>';
          };

          const renderOptions = () => giftIds.map((id, idx) => {
            const info = lookup[id];
            const disabled = (info && info.available === false) ? ' disabled' : '';
            const cls = (info && info.available === false) ? ' gift-selection-modal__option--unavailable' : '';
            return '<button class="gift-selection-modal__option' + cls + '" data-variant-id="' + id + '"' + disabled + '>'
              + buildInner(id, idx, info) + '</button>';
          }).join('');

          const modal = document.createElement('div');
          modal.id = 'gift-selection-modal';
          modal.className = 'gift-selection-modal';
          modal.innerHTML =
            '<div class="gift-selection-modal__overlay"></div>' +
            '<div class="gift-selection-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="gift-modal-title">' +
              '<button class="gift-selection-modal__close" aria-label="Uždaryti">&times;</button>' +
              '<h2 class="gift-selection-modal__title" id="gift-modal-title">Pasirinkite dovaną</h2>' +
              '<div class="gift-selection-modal__options">' + renderOptions() + '</div>' +
            '</div>';

          document.body.appendChild(modal);
          requestAnimationFrame(() => modal.classList.add('gift-selection-modal--open'));

          const resetButton = () => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          };

          const close = (cancelled) => {
            modal.classList.remove('gift-selection-modal--open');
            modal.addEventListener('transitionend', () => modal.remove(), { once: true });
            if (cancelled) resetButton();
          };

          const attachHandlers = () => {
            modal.querySelectorAll('.gift-selection-modal__option:not([disabled])').forEach(btn => {
              btn.addEventListener('click', () => {
                const selectedGiftId = Number(btn.dataset.variantId);
                close(false);
                const parentId = Number(formData.get('id'));
                // IO-5815: chained after the main add, as in the single-gift path above.
                this.addToCart(config, formData, addUrl)
                  .then(() => this.error ? null : fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      items: [{ id: selectedGiftId, quantity: 1, properties: { _gift_parent: parentId } }]
                    })
                  }))
                  .then(() => { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); })
                  .catch(() => {});
              });
            });
          };

          modal.querySelector('.gift-selection-modal__overlay').addEventListener('click', () => close(true));
          modal.querySelector('.gift-selection-modal__close').addEventListener('click', () => close(true));
          attachHandlers();

          // Enrich unknown variants via Storefront API if token is available
          const unknownIds = giftIds.filter(id => {
            const info = lookup[id];
            return !info || (!info.product_title && !info.title);
          });
          const token = window.shopifyStorefrontToken;
          if (unknownIds.length && token) {
            const gids = unknownIds.map(id => 'gid://shopify/ProductVariant/' + id);
            fetch(window.shopUrl + '/api/2026-04/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token,
              },
              body: JSON.stringify({
                query: 'query($ids:[ID!]!){nodes(ids:$ids){...on ProductVariant{id title availableForSale image{url}product{title}}}}',
                variables: { ids: gids },
              }),
            })
              .then(r => r.json())
              .then(json => {
                if (!json.data || !json.data.nodes || !modal.isConnected) return;
                json.data.nodes.forEach(node => {
                  if (!node) return;
                  const numericId = Number(node.id.split('/').pop());
                  const idx = giftIds.indexOf(numericId);
                  lookup[numericId] = {
                    id: numericId,
                    title: node.title,
                    product_title: node.product ? node.product.title : null,
                    available: node.availableForSale,
                    image: node.image ? node.image.url : null,
                  };
                  const btn = modal.querySelector('.gift-selection-modal__option[data-variant-id="' + numericId + '"]');
                  if (!btn) return;
                  btn.innerHTML = buildInner(numericId, idx, lookup[numericId]);
                  if (!node.availableForSale) {
                    btn.setAttribute('disabled', '');
                    btn.classList.add('gift-selection-modal__option--unavailable');
                  }
                });
                // Re-attach handlers after DOM update
                modal.querySelectorAll('.gift-selection-modal__option').forEach(b => {
                  const clone = b.cloneNode(true);
                  b.parentNode.replaceChild(clone, b);
                });
                attachHandlers();
              })
              .catch(() => {});
          }
        }


        handleErrorMessage(errorMessage = false, colors = null) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        // A Kaching alert can bring its own colours (collection-break "choose all items"); other messages reset them.
        this.errorMessageWrapper.style.backgroundColor = (colors && colors.background) || '';
        this.errorMessageWrapper.style.color = (colors && colors.color) || '';
        this.errorMessageWrapper.classList.toggle('product-form__error-message-wrapper--tinted', !!(colors && (colors.background || colors.color)));

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}